import { NpcRefuseChatMap } from "./SpendInterface";

let NpcChatMap : NpcRefuseChatMap = {
    // "大聪明":[
    //     "你是谁？"
    // ],
    // "老舅":[
    //     "你是谁？"
    // ],
    // "李阿姨":[
    //     "你是谁？"
    // ],
    // "大舅":[
    //     "你是谁？"
    // ],
    // "老六":[
    //     "你是谁？"
    // ],
    // "萧片子":[
    //     "你是谁？"
    // ],
    // "外婆":[
    //     "你是谁？"
    // ],
    // "小外甥":[
    //     "你是谁？"
    // ],
    // "皮鞋王子":[
    //     "你是谁？"
    // ],
    // "村口大爷":[
    //     "你是谁？"
    // ],
    // "周某人":[
    //     "你是谁？"
    // ],
    // "表姑":[
    //     "你是谁？"
    // ],
}

let NPcNotAgreenChatMap : NpcRefuseChatMap = {
    // "大聪明":[
    //     "嘿，你有没有觉得共享手机柜很有搞头？"
    // ],
    // "老舅":[
    //     "外甥，俺想整个陆游器，是不是很拽？"
    // ],
    // "李阿姨":[
    //     "你经常去按摩的吗？咱们一起弄一个，你出钱我出力"
    // ],
    // "大舅":[
    //     "外甥，我想承包一个旅游区，能投点钱不？"
    // ],
    // "老六":[
    //     "兄弟，你觉得新能源怎样？我有个好想法聊聊？"
    // ],
    // "萧片子":[
    //     "我想整个秘密项目，别让别人知道了？"
    // ],
    // "外婆":[
    //     "我想开菜市场，孙子投资我不？"
    // ],
    // "小外甥":[
    //     "我想做一个app,舅舅聊下吧？"
    // ],
    // "皮鞋王子":[
    //     "我想开个皮鞋厂，有兴趣不？"
    // ],
    // "村口大爷":[
    //     "我有一个广场项目，咱们聊聊？"
    // ],
    // "周某人":[
    //     "我想整个项目，疯狂环保的电瓶车，了解一下不？"
    // ],
    // "表姑":[
    //     "侄子，我想去温州搞批发，投资我点钱吧？"
    // ],
}

let NPcAgreenChatMap : NpcRefuseChatMap = {
    // "大聪明":[
    //     "谢谢你同意我的方案！"
    // ],
    // "老舅":[
    //     "谢谢你同意我的方案！"
    // ],
    // "李阿姨":[
    //     "谢谢你同意我的方案！"
    // ],
    // "大舅":[
    //     "谢谢你同意我的方案！"
    // ],
    // "老六":[
    //     "谢谢你同意我的方案！"
    // ],
    // "萧片子":[
    //     "谢谢你同意我的方案！"
    // ],
    // "外婆":[
    //     "谢谢你同意我的方案！"
    // ],
    // "小外甥":[
    //     "谢谢你同意我的方案！"
    // ],
    // "皮鞋王子":[
    //     "谢谢你同意我的方案！"
    // ],
    // "村口大爷":[
    //     "谢谢你同意我的方案！"
    // ],
    // "周某人":[
    //     "谢谢你同意我的方案！"
    // ],
    // "表姑":[
    //     "谢谢你同意我的方案！"
    // ],
}

export function getOneNpcRefuseChats(npcName:string){
    return NpcChatMap[npcName] || [];
}

export function getOneNpcAgreenChats(npcName:string){
    return NPcAgreenChatMap[npcName] || [];
}

export function getOneNpcNotAgreenChats(npcName:string){
    return NPcNotAgreenChatMap[npcName] || [];
}
